export interface DisplayShortDurationOptions {
  leading: boolean;
  maximumNumberOfUnits: number;
}

/**
 * No, absolutely not ashamed.
 * @see https://stackoverflow.com/questions/19700283/how-to-convert-time-milliseconds-to-hours-min-sec-format-in-javascript
 *
 * @param integer duration
 * @param DisplayShortDurationOptions customOptions
 *
 * @return string
 */
export const displayShortDuration = (
  duration: number,
  customOptions: Partial<DisplayShortDurationOptions> = {}
): string => {
  const { leading, maximumNumberOfUnits }: DisplayShortDurationOptions = {
    leading: false,
    maximumNumberOfUnits: 2,
    ...customOptions
  };
  let humanizedDuration: string[] = [];
  let unit = 'ms';

  const milliSeconds = Math.floor(duration % 1000);
  const seconds = Math.floor((duration / 1000) % 60);
  const minutes = Math.floor((duration / (1000 * 60)) % 60);
  const hours = Math.floor((duration / (1000 * 60 * 60)) % 24);

  if (seconds <= 0 && minutes <= 0 && hours <= 0) {
    humanizedDuration.push(`${milliSeconds}`);
  } else {
    humanizedDuration.push(`${seconds < 10 && (minutes > 0 || leading) ? '0' : ''}${seconds}`);
    unit = 's';

    if (minutes > 0 || hours > 0) {
      humanizedDuration.push(`${minutes < 10 && (hours > 0 || leading) ? '0' : ''}${minutes}`);
      unit = 'm';
    }

    if (hours > 0) {
      humanizedDuration.push(`${hours < 10 && leading ? '0' : ''}${hours}`);
      unit = 'h';
    }
  }

  if (humanizedDuration.length > maximumNumberOfUnits) {
    // keep only a max number of units
    humanizedDuration = humanizedDuration.slice(humanizedDuration.length - maximumNumberOfUnits);
  }

  return `${humanizedDuration.reverse().join(':')}${unit}`.trim();
};
